import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

export default function TrackingScripts() {
  // Meta Pixel ID (placeholder - user will provide later)
  const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || 'YOUR_PIXEL_ID';
  
  // GTM Container ID (placeholder - user will provide later)
  const GTM_ID = process.env.REACT_APP_GTM_ID || 'GTM-XXXXXXX';

  useEffect(() => {
    // Initialize Facebook Pixel
    if (typeof window !== 'undefined' && PIXEL_ID !== 'YOUR_PIXEL_ID') {
      !(function(f,b,e,v,n,t,s) {
        if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s);
      })(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      
      window.fbq('init', PIXEL_ID);
      window.fbq('track', 'PageView');

      console.log('Facebook Pixel initialized:', PIXEL_ID);
    }

    // Initialize Google Tag Manager
    if (typeof window !== 'undefined' && GTM_ID !== 'GTM-XXXXXXX') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
      });

      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
      document.head.appendChild(script);

      console.log('Google Tag Manager initialized:', GTM_ID);
    }

    // Initialize WATI WhatsApp Widget
    if (typeof window !== 'undefined') {
      const watiUrl = 'https://wati-integration-prod-service.clare.ai/v2/watiWidget.js?62547';
      const watiScript = document.createElement('script');
      watiScript.type = 'text/javascript';
      watiScript.async = true;
      watiScript.src = watiUrl;
      
      const watiOptions = {
        "enabled": true,
        "chatButtonSetting": {
          "backgroundColor": "#00e785",
          "ctaText": "Chat with us",
          "borderRadius": "25",
          "marginLeft": "0",
          "marginRight": "20",
          "marginBottom": "20",
          "ctaIconWATI": false,
          "position": "right"
        },
        "brandSetting": {
          "brandName": "MYeAI",
          "brandSubTitle": "Trading Compass Support",
          "brandImg": "",
          "welcomeText": "Hi there!\nHow can I help you?",
          "messageText": "Hello, %0A I have a question about {{page_link}}",
          "backgroundColor": "#00e785",
          "ctaText": "Chat with us",
          "borderRadius": "25",
          "autoShow": false,
          "phoneNumber": "15558834135"
        }
      };
      
      watiScript.onload = function() {
        if (typeof window.CreateWhatsappChatWidget === 'function') {
          window.CreateWhatsappChatWidget(watiOptions);
          console.log('WATI WhatsApp Widget initialized');
        }
      };
      
      const firstScript = document.getElementsByTagName('script')[0];
      firstScript.parentNode.insertBefore(watiScript, firstScript);
    }

    // Track Challenge Section View
    const handleScroll = () => {
      const challengeSection = document.querySelector('[data-testid="challenge-title"]');
      if (challengeSection) {
        const rect = challengeSection.getBoundingClientRect();
        if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
          if (window.fbq) {
            window.fbq('track', 'ViewContent', {
              content_name: '21-Day Challenge Section',
              content_category: 'Landing Page'
            });
          }
          if (window.dataLayer) {
            window.dataLayer.push({
              event: 'challenge_section_view',
              section: '21-day-challenge'
            });
          }
          // Remove listener after first trigger
          window.removeEventListener('scroll', handleScroll);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [PIXEL_ID, GTM_ID]);

  // Track CTA Clicks
  useEffect(() => {
    const handleCTAClick = (e) => {
      const button = e.target.closest('[data-testid*="button"]');
      if (button) {
        const testId = button.getAttribute('data-testid');
        
        if (window.fbq) {
          window.fbq('track', 'InitiateCheckout', {
            content_name: testId,
            content_category: 'CTA Click'
          });
        }
        
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'cta_click',
            cta_id: testId,
            cta_location: testId.includes('hero') ? 'hero' : testId.includes('challenge') ? 'challenge' : 'final'
          });
        }
      }
    };

    document.addEventListener('click', handleCTAClick);

    return () => {
      document.removeEventListener('click', handleCTAClick);
    };
  }, []);

  return (
    <Helmet>
      {/* Meta Pixel Noscript */}
      {PIXEL_ID !== 'YOUR_PIXEL_ID' && (
        <noscript>
          {`<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1" />`}
        </noscript>
      )}

      {/* GTM Noscript */}
      {GTM_ID !== 'GTM-XXXXXXX' && (
        <noscript>
          {`<iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`}
        </noscript>
      )}
    </Helmet>
  );
}